<template>
	<div class="full">
		<vxe-table :loading="loading" :data="data" height="90%" border :tooltip-config="{showAll:true}">
			<vxe-column type="seq" width="60"></vxe-column>
			<vxe-column field="showName" title="店铺名称"></vxe-column>
			<vxe-column field="salercpt_no" title="系统单号XD"></vxe-column>
			<vxe-column field="tp_tid" title="线上单号"></vxe-column>
			<vxe-column field="realPayment" title="买家实付"></vxe-column>
			<vxe-column field="tp_pay_time" title="付款时间">
				<template #default="{ row }">
					<span>{{$systemMethods.timestampToDate(row.tp_pay_time)}}</span>
				</template>
			</vxe-column>
			<vxe-column field="area" title="地区">
				<template #default="{ row }">
					<span>{{ row.tp_receiver_state+'/'+row.tp_receiver_city }}</span>
				</template>
			</vxe-column>
		</vxe-table>
	</div>
</template>
<style>

</style>
<style scoped>

</style>
<script>
	export default {
		props: {
			row: {
				type: Object,
				default: () => {
					return {}
				}
			},
			list: {
				type: Object,
				default: () => {
					return null
				}
			},
		},
		data() {
			return {
				data: [],
				loading: false
			}
		},
		watch: {

		},
		created() {

		},
		mounted() {
			if (this.row) {
				this.getData()
			}
		},
		computed: {

		},

		methods: {
			getData() {
				this.loading = true
				this.$api.crmcustomer.listDetail(this.row.id, {
					type: 'order'
				}).then((res) => {
					this.data = res
					this.loading = false
				}, () => {
					this.loading = false
				})
			},


		},
		components: {

		}
	}
</script>